/* eslint-disable import/no-unresolved */
import 'javascripts/showroom_fiat_v2/exclusive_and_national_offer_show';
import 'stylesheets/showroom_fiat_v2/exclusive_and_national_offer_show';
